var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyPreviewSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 125,
    viewBox: "0 0 143 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.3123 106.598C98.3123 106.598 121.013 83.898 121.013 55.798C121.013 27.698 98.2123 4.99792 70.3123 4.99792C42.3123 4.99792 19.6123 27.698 19.6123 55.798C19.6123 83.898 42.3123 106.598 70.3123 106.598Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.713 6.49795C125.259 6.49795 126.513 5.24435 126.513 3.69795C126.513 2.15155 125.259 0.897949 123.713 0.897949C122.166 0.897949 120.913 2.15155 120.913 3.69795C120.913 5.24435 122.166 6.49795 123.713 6.49795Z",
    fill: "#E7EBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3127 22.3979C23.8591 22.3979 25.1127 21.1443 25.1127 19.5979C25.1127 18.0515 23.8591 16.7979 22.3127 16.7979C20.7663 16.7979 19.5127 18.0515 19.5127 19.5979C19.5127 21.1443 20.7663 22.3979 22.3127 22.3979Z",
    fill: "#E7EBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2127 76.3979C8.08458 76.3979 10.4127 74.0698 10.4127 71.1979C10.4127 68.326 8.08458 65.9979 5.2127 65.9979C2.34081 65.9979 0.0126953 68.326 0.0126953 71.1979C0.0126953 74.0698 2.34081 76.3979 5.2127 76.3979Z",
    fill: "#E7EBF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1993_1924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.624 29.1149V87.9525C118.624 89.6788 117.185 91.1174 115.459 91.1174H26.0516C24.3253 91.1893 22.8867 89.7508 22.8867 88.0245V29.1149C22.8867 27.3167 24.3253 25.95 26.0516 25.95H115.459C117.257 25.95 118.624 27.3886 118.624 29.1149Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.624 29.1149V33.6464H22.8867V29.1149C22.8867 27.3167 24.3253 25.95 26.0516 25.95H115.459C117.257 25.95 118.624 27.3886 118.624 29.1149Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5559 56.4476C59.0257 56.4476 60.2172 55.2561 60.2172 53.7863C60.2172 52.3164 59.0257 51.1249 57.5559 51.1249C56.086 51.1249 54.8945 52.3164 54.8945 53.7863C54.8945 55.2561 56.086 56.4476 57.5559 56.4476Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0257 56.4476C85.4955 56.4476 86.6871 55.2561 86.6871 53.7863C86.6871 52.3164 85.4955 51.1249 84.0257 51.1249C82.5559 51.1249 81.3643 52.3164 81.3643 53.7863C81.3643 55.2561 82.5559 56.4476 84.0257 56.4476Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.107 73.9263H66.7632C65.4685 73.9263 64.3896 72.8474 64.3896 71.5526C64.3896 70.2579 65.4685 69.179 66.7632 69.179H75.035C76.3297 69.179 77.4087 70.2579 77.4087 71.5526C77.4806 72.8474 76.4017 73.9263 75.107 73.9263Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1307 31.1286C27.7266 31.1286 28.2097 30.6456 28.2097 30.0497C28.2097 29.4538 27.7266 28.9708 27.1307 28.9708C26.5349 28.9708 26.0518 29.4538 26.0518 30.0497C26.0518 30.6456 26.5349 31.1286 27.1307 31.1286Z",
    fill: "#F9FAFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5115 31.1286C31.1074 31.1286 31.5905 30.6456 31.5905 30.0497C31.5905 29.4538 31.1074 28.9708 30.5115 28.9708C29.9157 28.9708 29.4326 29.4538 29.4326 30.0497C29.4326 30.6456 29.9157 31.1286 30.5115 31.1286Z",
    fill: "#F9FAFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9638 31.1286C34.5596 31.1286 35.0427 30.6456 35.0427 30.0497C35.0427 29.4538 34.5596 28.9708 33.9638 28.9708C33.3679 28.9708 32.8848 29.4538 32.8848 30.0497C32.8848 30.6456 33.3679 31.1286 33.9638 31.1286Z",
    fill: "#F9FAFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.74 18.3254C114.02 18.3254 113.445 17.75 113.445 17.0307V2.57304C113.445 1.85375 114.02 1.27832 114.74 1.27832C115.459 1.27832 116.034 1.85375 116.034 2.57304V17.0307C116.034 17.75 115.459 18.3254 114.74 18.3254Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.241 29.4024C125.241 28.6831 125.817 28.1077 126.536 28.1077H140.994C141.713 28.1077 142.288 28.6831 142.288 29.4024C142.288 30.1217 141.713 30.6971 140.994 30.6971H126.536C125.817 30.6971 125.241 30.1217 125.241 29.4024Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.09 20.0517C123.587 19.5482 123.587 18.6851 124.09 18.1816L134.376 7.96771C134.88 7.46421 135.743 7.46421 136.246 7.96771C136.75 8.47121 136.75 9.33436 136.246 9.83786L126.032 20.0517C125.457 20.5552 124.594 20.5552 124.09 20.0517Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1993_1924",
    x: 0.886719,
    y: 14.95,
    width: 139.737,
    height: 109.17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1993_1924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1993_1924",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPreviewSvg);
export default __webpack_public_path__ + "static/media/EmptyPreviewSvg.149fa5d6.svg";
export { ForwardRef as ReactComponent };